module.exports = __webpack_public_path__ + "img/6_106.aabc0acc.png";